import { FC, useEffect, useState } from 'react';
import ModalReopenTicket from './index';
import { ModalReopenTicketControllerInterface } from './indexModel';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import emitter from '../../../../../core/shared/emitter';
import UserService from '../../../../../services/user-service';
import { AppRequesterController } from '../../../../../services/appRequester/appRequesterController';
import { setShowAlertFeedback } from '../../../../../store/internal';

const AppRequesterConst = new AppRequesterController();

const ModalReopenTicketController: FC<ModalReopenTicketControllerInterface> = (props) => {
  const { t } = useTranslation('ModalReopenTicket');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<{ ticketId: string, ticketReferenceId: string }>(null);
  const [loadingReopen, setLoadingReopen] = useState(false);

  useEffect(() => {
    emitter.on('open-modal-reopen-ticket', data => {
      setData(data);
    });

    return () => {
      emitter.off('open-modal-reopen-ticket');
    }
  }, []);

  const handleSubmit = () => {
    reopenTicket();
  }

  const reopenTicket = () => {
    if (data) {
      const headers  = UserService.getHeaders();
      const ticket_id = `${data.ticketId}`;
      const ticket_reference_id = `${data.ticketReferenceId}`;

      AppRequesterConst.Put(
        `/ticket/reopen-ticket/${ticket_id}`, {}, { headers },
        () => {},
        () => {
          dispatch(setShowAlertFeedback({ message: t('alert.reopened_successfully', { ticket_reference_id }), visibility: true, signalIcon: true }));
          props.hide(true, ticket_id);
        },
        (error) => {
          if (error.response.status === 400 && error.response.data.code_cxpress === 734) {
            dispatch(setShowAlertFeedback({ message: t('alert.consumer_deleted'), visibility: true, signalIcon: false }))
          } else {
            dispatch(setShowAlertFeedback({ message: t('alert.unexpected_error'), visibility: true, signalIcon: false }));
          }
        },
        navigate, dispatch, setLoadingReopen
      );
    }
  }

  return (
    <ModalReopenTicket 
      t={t}
      show={props.show}
      hide={props.hide}
      data={data}
      loadingReopen={loadingReopen}
      handleSubmit={handleSubmit}
    />
  );
};

export default ModalReopenTicketController;
